import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const products = [
  {
    name: "九眼天珠手鍊",
    category: "西藏天珠",
    desc: "至尊守護，財富智慧",
    price: "NT$ 12,800",
    tag: "人氣首選",
    img: "https://readdy.ai/api/search-image?query=nine%20eye%20Tibetan%20dzi%20bead%20bracelet%20on%20white%20marble%20surface%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20elegant%20minimalist%20style%20high%20detail%20texture%20close%20up&width=500&height=500&seq=prod001&orientation=squarish",
  },
  {
    name: "天然紫水晶手鍊",
    category: "天然水晶",
    desc: "智慧靈性，平靜安定",
    price: "NT$ 3,600",
    tag: "熱銷推薦",
    img: "https://readdy.ai/api/search-image?query=amethyst%20purple%20crystal%20bracelet%20on%20white%20marble%20surface%20luxury%20jewelry%20product%20photography%20soft%20purple%20light%20elegant%20minimalist%20style%20high%20detail%20texture&width=500&height=500&seq=prod002&orientation=squarish",
  },
  {
    name: "翡翠玉石吊墜",
    category: "翡翠玉石",
    desc: "吉祥守護，溫潤典雅",
    price: "NT$ 8,500",
    tag: "精品典藏",
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20pendant%20necklace%20on%20white%20marble%20surface%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20style%20high%20detail&width=500&height=500&seq=prod003&orientation=squarish",
  },
  {
    name: "手繪唐卡佛牌",
    category: "唐卡佛牌",
    desc: "信仰藝術，心靈守護",
    price: "NT$ 6,800",
    tag: "文化珍品",
    img: "https://readdy.ai/api/search-image?query=Tibetan%20thangka%20painting%20small%20Buddhist%20amulet%20pendant%20on%20dark%20velvet%20background%20luxury%20art%20product%20photography%20warm%20golden%20light%20cultural%20heritage%20collectible%20high%20detail&width=500&height=500&seq=prod004&orientation=squarish",
  },
];

export default function FeaturedProducts() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="featured" className="py-28 md:py-36 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div
          className={`flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#8b6f47]"></span>
              <span
                className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                FEATURED
              </span>
            </div>
            <h2
              className="text-[#2d2520] font-bold leading-[1.4]"
              style={{
                fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
                fontFamily: "'Noto Serif TC', serif",
              }}
            >
              人氣精選
            </h2>
          </div>
          <p
            className="text-[#7a6a5a] max-w-sm leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            每一件精選商品都承載著獨特的能量與文化意涵，等待與有緣人相遇。
          </p>
        </div>

        {/* Product Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          data-product-shop
        >
          {products.map((product, i) => (
            <div
              key={product.name}
              className={`group cursor-pointer transition-all duration-1000`}
              style={{
                transitionDelay: `${i * 100}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(24px)",
              }}
            >
              {/* Image Container */}
              <div className="relative w-full h-72 rounded-2xl overflow-hidden mb-5 bg-[#f5f0e8]">
                <img
                  src={product.img}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Tag */}
                <div className="absolute top-4 left-4">
                  <span
                    className="px-3 py-1.5 bg-[#2d2520]/80 backdrop-blur-sm text-white text-[0.875rem] rounded-full font-medium"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {product.tag}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div>
                <p
                  className="text-[#8b6f47] text-[1rem] font-medium mb-1"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  {product.category}
                </p>
                <h3
                  className="text-[#2d2520] font-bold mb-1"
                  style={{
                    fontSize: "clamp(1.125rem, 1.5vw, 1.375rem)",
                    fontFamily: "'Noto Serif TC', serif",
                  }}
                >
                  {product.name}
                </h3>
                <p
                  className="text-[#7a6a5a] mb-4"
                  style={{
                    fontSize: "1.1875rem",
                    fontFamily: "'Noto Serif TC', serif",
                  }}
                >
                  {product.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span
                    className="text-[#2d2520] font-bold text-[1.25rem]"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {product.price}
                  </span>
                  <button
                    onClick={() => navigate(`/products?category=${product.category}`)}
                    className="px-5 py-2.5 bg-[#8b6f47] text-white rounded-full text-[1rem] font-medium cursor-pointer hover:bg-[#7a5f3a] transition-all duration-300 whitespace-nowrap"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    查看商品
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div
          className={`text-center mt-14 transition-all duration-1000 delay-400 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <button
            onClick={() => navigate("/products")}
          className="inline-flex items-center gap-3 px-10 py-4 border-2 border-[#2d2520] text-[#2d2520] rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-[#2d2520] hover:text-white transition-all duration-300 whitespace-nowrap"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            前往商城
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
